import userAdressSection from "../../components/userAdressSection/index.vue";

export default {
  name: "userAdress",
  components: {
    userAdressSection,
  },
};
